import { InjectionKey } from 'vue'
import Vuex,{ createStore, Module, useStore as baseUseStore, Store } from 'vuex'




export const store = new Vuex.Store({
  state: {},
  modules: {
    
  }
})